import React from 'react';
import Image from 'next/image';
import Section from './Section';
import { WORK_EXPERIENCE_EN } from './index';
import AdviceAvatar from '@/assets/resume-advice/advice-avatar.png';

const WorkExperienceAdvice = () => {
  const [selectedTitle, setSelectedTitle] = React.useState('');

  return (
    <ul className="m-0 list-none">
      <Section
        title="着笔之前，你应该了解岗位角色"
        adviceIndex={1}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-work-experience-3/"
        sectionGroup={WORK_EXPERIENCE_EN}
        isRecommend={true}
        defaultChecked={true}
      >
        <div className="bg-green-50 px-3 py-4 rounded-lg flex mb-8">
          <Image
            src={AdviceAvatar}
            alt=""
            style={{ width: 24, height: 24 }}
            className="shrink-0"
          />
          <span className="text-green-700 ml-2">
            岗位角色是真正决定<strong>职业定位</strong>和
            <strong>工作价值</strong>的东西
          </span>
          <span className="ml-auto shrink-0 self-center">👍 12</span>
        </div>
        <p className="leading-6.5 mb-4">
          <strong>岗位角色：</strong>
          指的是你在某个职位上实际承担的内在职能和责任。它不仅仅是职位名称所代表的工作，而是你在这个职位中所扮演的具体角色和执行的核心任务。岗位角色决定了你的职业定位、工作价值以及核心能力要求，是影响职场晋升和发展的关键因素。
        </p>
        <ul className="m-0 list-none leading-6.5 text-black/85">
          <li className="mb-4">
            <strong>岗位角色的层级分类：</strong>
            <ul className="!ml-10 list-disc">
              <li>
                <strong>协调者：</strong>听从指令，进行协调工作。
              </li>
              <li>
                <strong>执行者：</strong>听从指令，完成一线任务。
              </li>
              <li>
                <strong>项目把控者：</strong>管理项目但不负责人员管理。
              </li>
              <li>
                <strong>团队管理者：</strong>
                管理团队成员，但不对最终结果负全责。
              </li>
              <li>
                <strong>业务负责人：</strong>对所管理的业务领域承担全部责任。
              </li>
            </ul>
          </li>
          <li>
            <strong>岗位角色的重要性：</strong>
            <ul className="!ml-10 list-disc">
              <li>
                <strong>塑造职业定位：</strong>
                <ul className="!ml-5 list-disc">
                  <li>
                    岗位角色概述是工作经历中最重要的部分，可以帮助你有效塑造职业形象。如果没有这一概述，用人单位可能会误解或低估你的职业角色。通过简明的岗位角色陈述，你可以从“执行者”上升到“把控者”甚至“负责人”的角色定位，提升简历的影响力。
                  </li>
                </ul>
              </li>
              <li>
                <strong>求职匹配度：</strong>
                <ul className="!ml-5 list-disc">
                  <li>
                    求职时，了解用人单位对该职位的实际角色要求非常重要。不同的岗位角色对核心能力的要求不同。如果你理解的岗位角色与用人单位的要求不一致，在面试中容易暴露出这种差异。如果用人单位需要的是执行者，而你具备业务负责人的能力，这种不匹配会让你在实际工作中感到受限，进而影响工作满意度和职业发展。
                  </li>
                </ul>
              </li>
              <li>
                <strong>职业发展规划：</strong>
                <ul className="!ml-5 list-disc">
                  <li>
                    职场晋升往往是岗位角色的升迁。职位名称可能会随着晋升而改变，如从“经理”到“高级经理”，再到“总监”，但真正的变化在于岗位角色的升级。了解岗位角色在升迁时需要的核心能力，如从执行者到把控者需要增加项目管理能力，从把控者到管理者需要加强人员管理能力，有助于你更好地规划职业发展，提前培养相应的技能。
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </Section>
      <Section
        title="如何以岗位角色为视角精准呈现自身能力？"
        adviceIndex={2}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-work-experience-5/"
        sectionGroup={WORK_EXPERIENCE_EN}
        isRecommend={true}
      >
        <div className="bg-green-50 px-3 py-4 rounded-lg flex mb-8">
          <Image
            className="shrink-0"
            src={AdviceAvatar}
            alt=""
            style={{ width: 24, height: 24 }}
          />
          <span className="text-green-700 ml-2">
            <strong>以岗位角色为视角来呈现自己的核心能力</strong>
            ，而不是以流水账的方式记录自己做了什么具体工作。
          </span>
          <span className="ml-auto shrink-0 self-center">👍 12</span>
        </div>
        <ul className="m-0 list-none leading-6.5 text-black/85">
          <li className="mb-4">
            <strong>第一步，明确自身岗位角色</strong>
            <ul className="!ml-6 list-disc">
              <li>
                一般而言：协调者、执行者、项目把控者、团队管理者、业务负责人这几个层级
              </li>
            </ul>
          </li>
          <li className="mb-4">
            <strong>第二步， 梳理岗位角色与核心能力的关系</strong>
            <ul className="!ml-6 list-disc">
              <li>
                每个岗位角色都有其特定的核心能力要求。职位名称只是表象，而岗位角色是你实际执行的核心任务与职责。岗位角色层级越高，核心能力要求越复杂。以产品经理为例：
                <ul className="!ml-5 list-disc">
                  <li>
                    <strong>协调者和执行者：</strong>
                    专注于基本任务执行，如产品设计、用户调研、行业研究、产品运营，以及沟通协调能力。
                  </li>
                  <li>
                    <strong>项目把控者：</strong>
                    在基础能力之上，强调项目管理、关键节点把控、推动结果达成的能力，以及对产品关键要素的分析和优化能力。
                  </li>
                  <li>
                    <strong>团队管理者：</strong>
                    需展示团队管理和领导力，尤其是在人员管理、团队发展上的核心能力。
                  </li>
                  <li>
                    <strong>业务负责人：</strong>
                    需要体现对产品关键资源的把控能力、商业思维、以及对整体业务负责的能力。
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <li>
            <strong>第三步，以核心能力做为关键词来开展描述</strong>
            <ul className="!ml-6 list-disc">
              <li>
                避免流水账式的罗列工作内容。相反，你需要从岗位角色的视角出发，围绕核心能力展开描述。
                <ul className="!ml-5 list-disc">
                  <li>
                    例如，作为一个项目把控者，不仅要说明你参与了哪些项目，还要重点描述你如何通过项目管理能力推动项目成功，如何分析和优化产品策略，如何确保项目在预算和时间范围内完成。
                  </li>
                </ul>
              </li>
              <li>
                你的描述应紧密围绕角色要求的核心能力展开，避免不必要的细节，确保每一条职责描述都能清晰传递出你的职业定位和能力。
              </li>
              <li>
                用实际案例支撑核心能力。
                <ul className="!ml-5 list-disc">
                  <li>
                    例如，如果你作为团队管理者，成功带领团队完成了一个重要的产品发布，可以具体说明你如何通过领导力和沟通协调，帮助团队克服挑战，实现目标。这样的描述不仅展示了你的核心能力，也为用人单位提供了你实际工作表现的有力证据。
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </Section>
      <Section
        title="一段完整的工作经历包含哪些内容？"
        adviceIndex={3}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-work-experience-1/"
        sectionGroup={WORK_EXPERIENCE_EN}
      >
        <ul className="!ml-5 list-disc leading-6.5 text-black/85">
          <li>
            <strong>基础信息：</strong>公司名、职位名称、就职时间；
          </li>
          <li>
            <strong>整体概述：一句话，树立起你的角色定位；</strong>
          </li>
          <li>
            <strong>职责描述：</strong>
            就职期间主要负责的职责，一般使用项目符号，
            <strong>强化你的职业形象</strong>；
          </li>
          <li>
            <strong>工作成果：</strong>
            工作的具体成果，可以单独做为一个段落来讲，也可以合并放在职责描述里一起说，
            <strong>真实、客观地呈现与你角色相关的成果</strong>。
          </li>
        </ul>
      </Section>
      <Section
        title="工作经历中的整体概述：梳理角色定位"
        adviceIndex={4}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-work-experience-2/"
        sectionGroup={WORK_EXPERIENCE_EN}
      >
        <div className="bg-green-50 px-3 py-4 rounded-lg flex mb-2">
          <Image
            src={AdviceAvatar}
            alt=""
            style={{ width: 24, height: 24 }}
            className="shrink-0"
          />
          <span className="text-green-700 ml-2">
            强调你所承担的责任和角色对整体项目或公司的影响力；确保概述中突出
            <strong>核心职责</strong>，而不是细节性工作。
          </span>
          <span className="ml-auto shrink-0 self-center">👍 12</span>
        </div>
        <p className="mb-8 leading-6.5 text-green-900/70">
          许多求职者常犯的错误是直接进入职责描述，而忽略了对岗位角色和主要责任的概述。如果缺少这一部分，特别是当你承担了管理职能或对最终结果负责时，错失展示自己核心价值的机会。
        </p>
        <p className="leading-6.5 mb-4">
          整体概述的目的是从<strong>角色</strong>
          的角度明确你的主要职责，而不是简单罗列所有的工作内容。如果缺少这一部分，你的角色可能被误认为是执行者或协调员，而非管理者或决策者。
        </p>
        <div className="border border-[#219653] border-dashed p-4 rounded-lg mb-8 text-black/85 leading-6.5">
          <p className="font-semibold mb-2">错误示例（工作汇总）：</p>
          <p className="mb-4">
            “协助管理产品定价，进行市场情报分析，支持基于数据的决策和战略规划，促进新品上市流程。”
          </p>
          <p className="font-semibold mb-2">正确示例（角色陈述）：</p>
          <p>
            “负责管理亚太地区电动工具系列产品的定价策略、市场情报分析和营销效果监测。”
          </p>
        </div>
        <p className="text-black/85 leading-6.5">
          通过修改后，求职者的角色定位从一个“执行者”转变为“管控者”，展示了更强的职业形象。
        </p>
      </Section>
      <Section
        title="工作经历中的职责描述：强化职业形象"
        adviceIndex={5}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-work-experience-2/"
        sectionGroup={WORK_EXPERIENCE_EN}
      >
        <div className="bg-green-50 px-3 py-4 rounded-lg flex mb-8">
          <Image
            src={AdviceAvatar}
            alt=""
            style={{ width: 24, height: 24 }}
            className="shrink-0"
          />
          <span className="text-green-700 ml-2">
            职责描述的关键在于<strong>强化你的职业定位和形象，</strong>
            而非简单记录你所做过的所有工作。
          </span>
          <span className="ml-auto shrink-0 self-center">👍 12</span>
        </div>
        <p className="mb-4 leading-6.5">以下几点可以帮助你有效强化职业形象：</p>
        <ul className="!ml-5 list-disc leading-6.5 text-black/85">
          <li className="mb-4">
            <strong>能力导向，而非工作导向：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                描述工作职责时，不应仅从“我做过什么”的角度出发，而应围绕“
                <strong>我具备哪些核心能力</strong>
                ”展开。你需要在职责描述中清晰呈现出自己作为该岗位的核心技能与能力。例如，一个产品经理可以直接以
                <strong>产品设计、产品管理和产品运营</strong>
                等关键词作为职责描述的核心，展示出在这些方面的能力与经验。
              </li>
            </ul>
          </li>
          <li className="mb-4">
            <strong>突出高层次能力，避免过度细化项目：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                虽然项目经验重要，但不必在职责描述中过多呈现细节，否则会让你看起来像执行者。项目细节可留到项目经历部分，职责描述应侧重你具备的高权重能力。
              </li>
            </ul>
          </li>
          <li>
            <strong>突出核心工作，控制条目数量：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                避免以段落形式列出过多工作内容，同时忽略了优先级。建议将职责条目控制在
                <strong>5条左右</strong>
                ，最多不超过7条。前2-3条应该着重呈现你在职位上最核心、最重要的工作内容，而次要的工作可以在后续简述。
              </li>
            </ul>
          </li>
        </ul>
      </Section>
      <Section
        title="工作经历中的工作成果：客观真实"
        adviceIndex={6}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-work-experience-2/"
        sectionGroup={WORK_EXPERIENCE_EN}
      >
        <div className="bg-green-50 px-3 py-4 rounded-lg flex mb-2">
          <Image
            src={AdviceAvatar}
            alt=""
            style={{ width: 24, height: 24 }}
            className="shrink-0"
          />
          <span className="text-green-700 ml-2">
            关键在于真实、客观地呈现与你角色相关的成果
          </span>
          <span className="ml-auto shrink-0 self-center">👍 12</span>
        </div>
        <p className="mb-8 leading-6.5 text-green-900/70">
          尽管许多求职者认为展示数字化成果非常重要，但其实，过度夸大或渲染反而可能降低你的职业形象。
        </p>
        <ul className="!ml-5 list-disc leading-6.5 text-black/85">
          <li className="mb-4">
            <strong>真实呈现，避免夸大：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                在简历上，<strong>真实</strong>
                的成果比夸张的数字和描述更能打动用人单位。当前市场上，许多求职者过于浮夸的自我包装已经引发了招聘方的警惕，因此建议你不必刻意渲染，只需如实呈现你的成果，这反而会让用人单位觉得你真实可信。
              </li>
            </ul>
          </li>
          <li className="mb-4">
            <strong>个人成果与团队成果的区分：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                不要混淆你的<strong>个人成果</strong>和<strong>团队成果</strong>
                ，这往往会让你的工作表现显得不够清晰甚至被认为在夸大。正确的做法是，先交代你的个人贡献，再补充团队整体的成就。例如：“主导全新产品策略和整套产品设计并获得管理层一致认可，上线后产品表现提升30%。”这里前半部分展示的是个人化成果，后半部分补充团队的成就。这样能够清晰传达你的个人价值。
              </li>
            </ul>
          </li>
          <li>
            <strong>避免过度细节化的数据展示：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                建议采用模糊化或概括性表达，如“增长30%”或“百万级用户”，避免透露核心指标。这种做法不仅避免了保密风险，也避免了显得不够专业。具体数字可以留到面试或项目经历中详细讨论。
              </li>
            </ul>
          </li>
        </ul>
      </Section>
      <Section
        title="岗位角色与职位名称有什么区别？"
        adviceIndex={7}
        selectedTitle={selectedTitle}
        setSelectedTitle={setSelectedTitle}
        link="https://www.tanzhi.cn/articles/resume-advice-work-experience-4/"
        sectionGroup={WORK_EXPERIENCE_EN}
      >
        <div className="bg-green-50 px-3 py-4 rounded-lg flex mb-8">
          <Image
            className="shrink-0"
            src={AdviceAvatar}
            alt=""
            style={{ width: 24, height: 24 }}
          />
          <span className="text-green-700 font-semibold ml-2">
            岗位角色是真正决定<strong>职业定位</strong>和
            <strong>工作价值</strong>的东西，而非职位名称。
          </span>
          <span className="ml-auto shrink-0 self-center">👍 12</span>
        </div>
        <ul className="!ml-5 list-disc leading-6.5 text-black/85">
          <li className="mb-4">
            <strong>岗位角色：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                指你在这个职位上具体承担的职能和责任，是职位名称背后实际的工作内容和角色定位。同一个职位，不同的用人单位的要求可能是不一样的。而这种要求最终其实就是反映在对不同岗位角色的要求。反过来，若两个职位有类似的岗位角色要求，那么用人单位希望的候选人就会很相似。所以决定一个职位真正要求的就是其岗位角色。
              </li>
            </ul>
          </li>
          <li>
            <strong>职位名称：</strong>
            <ul className="!ml-5 list-disc">
              <li>
                是职场中对某类职位的通用名称，如“产品经理”、“工程师”、“运营专员”、“销售经理”等。它们是标准化的称谓，用来描述某个工作的大致内容和职能范围。
              </li>
            </ul>
          </li>
        </ul>
      </Section>
    </ul>
  );
};

export default WorkExperienceAdvice;
